// Disable Focus on other than keyboard
// https://css-irl.info/accessibly-hiding-focus-outlines/

document.addEventListener("keyup", function (event) {
  /* if key is tab */
  if (event.which === 9) {
    document.documentElement.classList.remove("u-no-focus-outline");
    document.documentElement.classList.add("u-focus-outline");
  }
});

//  put your jQuery functions in here
(function ($) {
  // Simple vars
  var activeClass = "is-active",
    closedText = "Open menu",
    openText = "Close menu";

  $(".hamburger")
    .off("click")
    .on("click", function (evt) {
      evt.preventDefault();
      $("body").toggleClass("menu-open");
      // Store the hambuger and the screen reader text element
      var burger = $(this),
        srText = burger.find(".sr-only");

      // Toggle hamburger and text depending on state
      if (burger.hasClass(activeClass)) {
        // burger.parent().parent().removeClass('menu-open')
        burger.removeClass(activeClass).attr("title", closedText);

        srText.text(closedText);
      } else {
        // burger.parent().parent().addClass('menu-open')
        burger.addClass(activeClass).attr("title", openText);

        srText.text(openText);
      }
    });

  $(".main-nav").hover(function () {
    $(".global-wrapper").toggleClass("header_hover");
  });
  $(".sub-menu").click(function () {
    $(".sub-menu").removeClass("active");
  });
  $(".menu-item-has-children").mouseenter(function () {
    $(this).children(".sub-menu").addClass("active");
  });
  $(".menu-item-has-children").mouseleave(function () {
    $(this).children(".sub-menu").removeClass("active");
  });

  //  Tabs
  $(document).ready(function () {
    $(".tabbed a[aria-selected]").parents("li").addClass("active");
  });

  $(".tabbed").click(function () {
    $(".tabbed a[aria-selected]").parents("li").addClass("active");
    $(".tabbed a:not([aria-selected])").parents("li").removeClass("active");
  });
  // svg service
  $("#eiij5lmp8jea22").click(function () {
    window.location.href =
      "mailto:service@prokommunal.com?subject=Lieber Service... &body=...ich hab da mal eine Frage...";
  });

  /**
   * touchHover.js
   *
   * Create tooltips on mouseover or on click (for supporting touch interfaces).
   *
   * @author C. Scott Asbach
   */

  $(document).ready(function () {
    /**
     * store the value of and then remove the title attributes from the
     * abbreviations (thus removing the default tooltip functionality of
     * the abbreviations)
     */
    $("abbr").each(function () {
      $(this).data("title", $(this).attr("title"));
      $(this).removeAttr("title");
    });

    /**
     * when abbreviations are mouseover-ed show a tooltip with the data from the title attribute
     */
    $("abbr").mouseover(function () {
      // first remove all existing abbreviation tooltips
      $("abbr").next(".tooltip").remove();

      // create the tooltip
      $(this).after(
        '<span class="tooltip">' + $(this).data("title") + "</span>",
      );

      // position the tooltip 4 pixels above and 4 pixels to the left of the abbreviation
      var left = $(this).position().left + $(this).width() + 4;
      var top = $(this).position().top - 4;
      $(this).next().css("left", left);
      $(this).next().css("top", top);
    });

    /**
     * when abbreviations are clicked trigger their mouseover event then fade the tooltip
     * (this is friendly to touch interfaces)
     */
    $("abbr").click(function () {
      $(this).mouseover();

      // after a slight 2 second fade, fade out the tooltip for 1 second
      $(this)
        .next()
        .animate(
          { opacity: 0.9 },
          {
            duration: 2000,
            complete: function () {
              $(this).fadeOut(1000);
            },
          },
        );
    });

    /**
     * Remove the tooltip on abbreviation mouseout
     */
    $("abbr").mouseout(function () {
      $(this).next(".tooltip").remove();
    });
  });
})(jQuery);
